import { render, staticRenderFns } from "./DebtResidentForm.vue?vue&type=template&id=7bc6eb10"
import script from "./DebtResidentForm.vue?vue&type=script&lang=js"
export * from "./DebtResidentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports